import { TableBody } from 'components/Table/TableBody/TableBody';
import { queryKeys, queryParams, WORKLIST_REFETCH_INTERVAL } from 'utils/query';
import { TableConfig, TableInput } from 'models/general';
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getBillingRecords } from 'hooks/api/billing/getBillingRecords';
import { BillingRecordsColumns } from 'components/Table/Columns/BillingRecordsColumns';
import { BillingRecordDocument, BillingStatus } from 'models/billing';
import { BillingFilters } from 'components/Table/Filters/BillingFilters';
import { useTableActions } from 'components/Table/Actions/BillingActions';
import { DataFieldNames } from './BillingTable.config';

const billingConfig: TableConfig = {
  queryKey: queryKeys.billingRecords,
  dataFieldNames: DataFieldNames,
  defaultFilters: {
    [queryParams.status]: BillingStatus.ReadyToBill,
  },
  defaultSort: `-${DataFieldNames.date}`,
  refetchInterval: WORKLIST_REFETCH_INTERVAL,
};

export const Billing = () => {
  const queryClient = useQueryClient();
  const getBilling = useCallback(
    async (input: TableInput) => {
      const billingRecords = await getBillingRecords(queryClient, input);
      return billingRecords;
    },
    [queryClient],
  );

  return (
    <TableBody<BillingRecordDocument>
      getData={getBilling}
      getColumns={BillingRecordsColumns}
      config={billingConfig}
      filterBar={<BillingFilters config={billingConfig} />}
      selectableRowId={(item) => item?.id}
      selectedActions={useTableActions}
    />
  );
};
